import { Navigate, Outlet, useLocation } from "react-router-dom";
import NotFoundPage from "../PageNotFound";
import { getLinks } from "@/utils/Helper";
import { UserType } from "@/app/shared_enums/enums";

const ProtectedRoute = () => {
  const links = getLinks() || ["/"]; // Return landing page as default
  const isAuthenticated = Boolean(localStorage.getItem("userToken"));
  const userType = localStorage.getItem("userType") as unknown as UserType;
  const location = useLocation();
  const userSwitchInProgress =
    localStorage.getItem("userSwitchInProgress") === "true";

  // Don't redirect if user is switching
  if (!isAuthenticated && !userSwitchInProgress && location.pathname !== "/") {
    return <Navigate to="/login" />;
  }

  // Redirect RemoteUsers trying to access admin routes to user home
  if (userType === UserType.RemoteUser) {
    return <Navigate to="/user/home" />;
  }

  // Redirect to dashboard if authenticated and trying to access the login page
  if (isAuthenticated && location.pathname === "/login") {
    return <Navigate to={links[0]} />;
  }

  // Check if the current path is not in the links array and redirect to the first available link
  if (isAuthenticated) {
    if (
      links.some(
        (link) =>
          link === location.pathname || location.pathname.startsWith(link)
      )
    ) {
      return <Outlet />;
    } else if (links.length > 0) {
      return <NotFoundPage />;
    }
  }
  return <Outlet />;
};

export default ProtectedRoute;
